import { heroEquipment } from "../HeroEquipment";

export const leśneGobliny = {
  heroes: {
    "Herszt leśnych goblinów": {
      id: 0,
      startingEquipment: ["Sztylet", "Włócznia"],
      cost: 55,
      number: 1,
      equipmentList: heroEquipment["Plemię Leśnych Goblinów"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 7],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: [
        "Dowódca",
        "Dziwnie cuchnom",
        "Nadrzewni drapieżcy",
        "Strachliwy",
        "Wspinaczka",
        "Zasadzka",
      ],
      exp: 20,
      skills: [0, 1, 3, 4, 5],
    },
    "Szaman leśnych goblinów": {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Plemię Leśnych Goblinów"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 6],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: [
        "Dziwnie cuchnom",
        "Mag (Dziedzina Boga Pajonka)",
        "Nadrzewni drapieżcy",
        "Wspinaczka",
        "Zasadzka",
      ],
      exp: 12,
      skills: [0, 1, 4, 5],
    },
    "Traper leśnych goblinów": {
      id: 2,
      startingEquipment: ["Sztylet", "Broń miotana (noże)"],
      cost: 25,
      number: 2,
      equipmentList: heroEquipment["Plemię Leśnych Goblinów"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 5],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: [
        "Dziwnie cuchnom",
        "Nadrzewni drapieżcy",
        "Pułapkarz",
        "Ranger",
        "Wspinaczka",
        "Zasadzka",
        "Zwiadowca",
      ],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    "Rembajło leśnych goblinów": {
      id: 3,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Plemię Leśnych Goblinów"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 5],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: [
        "Dziwnie cuchnom",
        "Nadrzewni drapieżcy",
        "Szermierz",
        "Wspinaczka",
        "Zasadzka",
      ],
      exp: 8,
      skills: [0, 1, 3, 4, 5],
    },
    "Leśny goblin": {
      id: 4,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 15,
      number: 15,
      equipmentList: heroEquipment["Plemię Leśnych Goblinów"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 3, 3, 3, 1, 3, 1, 5],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: [
        "Animozja",
        "Chorążowie & sygnaliści",
        "Drużyna obsługi",
        "Dziwnie cuchnom",
        "Nadrzewni drapieżcy",
        "Rozmiar rzondzi",
        "Wspinaczka",
        "Zasadzka",
      ],
    },
    "Jeździec pajonków": {
      id: 5,
      startingEquipment: [
        "Sztylet",
        "Włócznia",
        "Tarcza",
        "Obmierzły pajonk",
        "Siodło & uprząż",
      ],
      cost: 70,
      number: 3,
      equipmentList: heroEquipment["Plemię Leśnych Goblinów"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 3, 3, 3, 1, 3, 1, 5],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
        "Obmierzły Pajonk": [7, 3, 0, 3, "-", "-", 4, 1, 2],
      },
      rules: [
        "Animozja",
        "Dziwnie cuchnom",
        "Kawalerzysta",
        "Lekka jazda",
        "Nadrzewni drapieżcy",
        "Rozmiar rzondzi",
        "Wspinaczka",
        "Zasadzka",
      ],
    },
    Snotling: {
      id: 6,
      startingEquipment: ["Broń improwizowana", "Wybuchowe zarodniki"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 0, 2, 2, 1, 3, 1, 4],
        Maksymalna: [4, 2, 0, 2, 2, 1, 3, 1, 4],
      },
      rules: [
        "Mięso armatnie",
        "Nieświadomy",
        "Rozmiar rzondzi",
        "Sfora",
        "Śmigły",
        "Wybuchowe zarodniki",
      ],
    },
    Pajonk: {
      id: 7,
      startingEquipment: ["Broń naturalna (zatruty atak)"],
      cost: 25,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [7, 3, 0, 3, 3, 1, 4, 1, 2],
        Maksymalna: [7, 3, 0, 3, 3, 1, 4, 1, 2],
      },
      rules: [
        "Łuskowata skóra (5+)",
        "Murołaz",
        "Niezłomny",
        "Oplątanie",
        "Rozmiar rzondzi",
        "Saper",
        "Zasadzka",
        "Zwierzę",
      ],
    },
    Troll: {
      id: 8,
      startingEquipment: ["Broń naturalna"],
      cost: 200,
      number: 1,
      equipmentList: {
        "Troll Górski": [50, 3, "Choice"],
        "Troll Rzeczny": [50, 3, "Choice"],
      },
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 1, 5, 4, 3, 1, 3, 4],
        Maksymalna: [6, 3, 1, 5, 4, 3, 1, 3, 4],
      },
      rules: ["Bycza szarża","Duży cel","Gatunki trolli","Głód trzewi","Głupota","Nieświadomy","Niezłomny","Przepastne trzewia","Regeneracja","Strach","Wielkolud","Żrąca plwocina"],
    },
    "Wielki pajonk": {
      id: 10,
      startingEquipment: ["Broń naturalna (zatruty atak)"],
      cost: 180,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [7, 3, 0, 4, 4, 3, 4, 3, 7],
        Maksymalna: [7, 3, 0, 4, 4, 3, 4, 3, 7],
      },
      rules: [
        "Głód trzewi",
        "Łuskowata skóra (4+)",
        "Murołaz",
        "Niezłomny",
        "Omotanie",
        "Oplątanie",
        "Potwór",
        "Wierzchowiec",
        "Zasadzka",
        "Zwierzę",
      ],
    },
    Rydwan: {
      id: 11,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        "Obmierzły Pajonk": [7, 3, 0, 3, "-", "-", 4, 1, 2],
        "Obmierzły Pajonk ": [7, 3, 0, 3, "-", "-", 4, 1, 2],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Plemię Leśnych Goblinów",
  nature: "Zła",
  armyRules: ["Podatek", "Rozrzutność"],
  mercenaries: ["Czarny Ork","Grzybowar","Mekaniak"],
};
